import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar22Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar22 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar22Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar22">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M143.421 245.217c-26.278-4.551-73.66 9.382-95.935 16.904 27.207 25.753 63.93 41.545 104.347 41.545 28.819 0 55.764-8.031 78.721-21.972-21.932-13.059-62.024-32.132-87.125-36.477h-.008Z"
            fill="#000"
          />
          <Path
            id="skin"
            d="M232.016 166.346c2.47-13.115-.969-12.813-.969-29.701 4.52-46.97-13.536-90.827-43.865-90.827-83.749 0-92.13 21.845-92.13 72.994 0 2.661 3.21 4.647 3.464 7.395-7.943 0-10.692 14.45-7.213 24.697 8.15 24.013 25.015 23.616 25.396 23.409 3.162 7.07-4.957 44.731-6.156 53-3.186 21.845-18.866 22.162-18.866 22.162s47.018 44.627 103.624 48.52c6.815-11.058-9.437-34.483-16.475-39.829-4.195-2.399 2.661-24.141 3.503-38.145 5.791.079 19.517 8.96 27.262-9.445 4.012-9.532 19.398-28.097 22.433-44.222l-.008-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector_2"
            d="M148.299 121.703s12.257-4.043 21.773-4.011c11.185.032 19.009 7.745 21.178 3.773.691-1.263.254-7.888-20.121-9.969-9.12-.929-14.505 3.527-22.83 10.207Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M186.26 140.783c-2.415-5.56-6.879-10.946-13.067-12.868-2.812-.675-5.728-.699-8.571.024-2.32.579-4.194 1.779-6.006 2.986-2.414 1.271-5.298.334-7.943-.302 2.319 2.074 5.894 3.94 9.151 2.789a27.036 27.036 0 0 1 2.288-.993c-.048.222-.096.437-.128.667-.492 4.131 2.566 7.896 6.84 8.404 4.274.509 8.134-2.423 8.635-6.553.039-.342.047-.675.047-1.001 2.868 1.755 5.664 4.178 8.746 6.839l.008.008Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            d="M232.302 114.864c-12.996-.921-22.218 6.967-20.931 10.073.794 1.922 3.447 2.097 5.489.032 5.56-5.052 9.667-3.146 15.291-3.027.207-2.161.111-5.274.151-7.086v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M234.947 133.349c-1.653-1.414-3.376-2.828-5.608-3.686-2.733-1.057-5.632-1.382-8.5-1.049-6.371 1.168-11.447 5.99-14.505 11.225 1.732-1.168 3.384-2.288 4.997-3.289.301 3.662 3.455 6.537 7.316 6.537 4.059 0 7.347-3.177 7.347-7.101a6.792 6.792 0 0 0-1.064-3.63c2.629.294 5.417 1.31 8.515 3.312 3.098 1.533 6.872.103 9.421-1.684-2.7.31-5.671.906-7.919-.643v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            opacity={0.75}
            d="M131.593 199.089c0 .406 2.518 19.565 26.682 36.811 10.216 7.292 12.774 8.643 20.193 10.748 1.104-6.355 3.845-26.643 3.845-26.643-.398.04-30.925-5.934-50.728-20.923l.008.007Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_7"
            opacity={0.75}
            d="M213.968 166.497c-1.049-.643-2.391 2.526-5.863 2.526-2.367 0-4.933-3.328-10.978-3.018-3.614.182-4.75 3.662-4.043 4.424.707.755 2.216.175 4.552.278 3.32.143 4.837 2.018 10.278 1.676 5.339-.333 7.094-5.242 6.054-5.886Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_8"
            opacity={0.75}
            d="M205.889 180.724c-3.106 0-4.099 1.573-4.099 1.573s-3.948-1.922-7.244-1.922c-3.297 0-6.307 1.747-9.405 2.184-3.138.445-8.556-.103-8.556-.103s-.031.317 0 .341c0 0 12.591 15.498 24.332 15.498 10.096 0 12.074-11.534 12.336-12.177.008-.024.016-.032.016-.032s-4.266-5.362-7.372-5.362h-.008Zm-4.337 10.74c-12.575 0-24.871-8.603-24.871-8.603 3.638 2.264 12.042 3.948 24.633 3.948 5.751 0 11.756-.604 11.756-.604-3.098 1.462-5.719 5.259-11.518 5.259Z"
            fill="#2E2017"
          />
          <Path
            id="hair"
            d="M260.279 188.255c-5.107-23.68-14.862-22.751-16.252-32.037-1.39-9.286 13.003-56.884-4.647-78.474-17.643-21.59-60.594-58.505-88.921-45.74-.071.032-.135.072-.206.104-12.829-3.082-26.992-2.876-41.219 4.06-47.717 23.25-49.48 99.381-53.596 107.07-5.846 10.939-3.209 1.319-18.103 22.624-14.894 21.304 3.21 40.162 3.21 40.162s-5.847-32.052-.374-8.865c5.465 23.196 32.434 26.397 32.434 26.397s-1.128-1.509-2.828-15.085C72.23 230.157 94.1 229.776 94.1 229.776l-1.51-9.239s4.338 11.312 12.257 11.503c1.692.039 3.321-.175 4.854-.533.326-1.302.612-2.7.834-4.202 1.208-8.269 9.326-45.922 6.156-52.999-.381.206-17.245.611-25.395-23.41-2.828-8.333-3.074-27.937 17.277-24.069 3.249 5.306 8.841 13.091 13.631 12.853 2.169-6.76 9.413-11.455 10.716-11.669 34.841-5.855 56.701-39.758 65.249-55.844 4.21-1.898 8.952-2.86 13.639-1.39 4.837 1.517 20.319 16.817 19.239 65.86 0 16.888 3.432 16.587.969 29.701-3.034 16.134-18.421 34.698-22.433 44.222-7.744 18.397-21.463 9.524-27.262 9.445-.238 3.972-.961 8.571-1.779 13.178l-.795 5.41s15.363.993 25.126-2.367c3.328-1.144 14.878-7.697 14.878-7.697l-8.269 6.267s12.114 1.223 22.623-8.762c-1.104 1.843-3.535 5.41-3.535 5.41s16.245-8.603 20.654-27.644c.468 8.587-2.558 16.713-2.558 16.713s16.713-8.587 11.605-32.274l.008.016Z"
            fill={c.hair}
          />
        </G>
      </G>
    </Svg>
  );
};
